import { NavLink as RouterNavLink, useLocation } from "react-router-dom";
import { forwardRef, useMemo } from "react";
import { cn } from "../lib/utils";

const NavLink = forwardRef(
	({ className, activeClassName, pendingClassName, to, matchSearch, ...props }, ref) => {
		const location = useLocation();

		const currentSearch = useMemo(() => new URLSearchParams(location.search), [location.search]);

		const searchMatches = useMemo(() => {
			if (!matchSearch) {
				return true;
			}

			return Object.entries(matchSearch).every(([key, expectedValue]) => {
				const currentValue = currentSearch.get(key);

				if (expectedValue === null) {
				return currentValue === null;
				}

				return currentValue === String(expectedValue);
			});
		}, [currentSearch, matchSearch]);

		return (
			<RouterNavLink
				ref={ref}
				to={to}
				className={({ isActive, isPending }) =>
					cn(
						className,
						isActive && searchMatches && activeClassName,
						isPending && pendingClassName
					)
				}
				{...props}
			/>
		);
	}
);

NavLink.displayName = "NavLink";

export { NavLink };